import { useEffect, useState } from "react";
import { useHistory, Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
//UI
import { Form, Button, Icon } from "semantic-ui-react";
import { status } from "../../../../containers/resources/optionsList";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";
import HeadDetail from "../../../../components/headDetail";
import HeadDetailReservation from "../../../../components/headDetailReservation";
import "semantic-ui-css/semantic.min.css";
//ACTION
import { createPassengerBySpace } from "../../../../redux/actions/reservations/spacePassenger/createPassengerBySpace";
import { initialStatePassengerBySpace, } from "../../../../redux/actions/reservations/spacePassenger/fetchPassengerBySpace";
import { updatePassengerBySpace } from "../../../../redux/actions/reservations/spacePassenger/updatePassengerBySpace";
import { verifyPassenger, initialStateVerifyPassenger, } from "../../../../redux/actions/reservations/spacePassenger/verifyPassenger";
import { fetchPassengerBySpaceFormCustom, initialStatePassengerBySpaceFormCustom } from "../../../../redux/slices/custom/reservations/cruise/passengerBySpace/customPassengerBySpaceForm.slice";
// Resources
import { scrollToTop } from "../../../resources/utils";
import { DateInput } from "semantic-ui-calendar-react";
import NoteSelector from "../../../../components/NoteSelector";
import GenderIcon from "../../../../components/reservation/genderIcon";

export default function PassengerBySpaceForm() {
  let history = useHistory();
  const [state, setState] = useState({ open: false, vertical: "top", horizontal: "center", });
  const { vertical, horizontal, open } = state;
  const { cruise_id, reservation_id, booking_id, passenger_id, space_id, spacePassenger_id } = useParams();
  const { t } = useTranslation();
  const { register, handleSubmit, errors, getValues, setValue, watch } = useForm();
  const passengerBySpaceStateCustom = useSelector((state) => state.customPassengerBySpaceForm);
  const passengerBySpaceState = useSelector((state) => state.passengerBySpaceReducer);
  const verifyPassengerState = useSelector((state) => state.verifyPassengerReducer);
  const [noteTransfer, setNoteTransfer] = useState();
  const [cleanList, setCleanList] = useState();
  const [passengerId, setPassengerId] = useState();
  const [birthdateInCruise, setBirthdateInCruise] = useState(false);
  const [date, setDate] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPassengerBySpaceFormCustom('', space_id, spacePassenger_id, cruise_id, reservation_id, booking_id,));
    scrollToTop();
    return () => {
      dispatch(initialStatePassengerBySpaceFormCustom());
      dispatch(initialStatePassengerBySpace());
      dispatch(initialStateVerifyPassenger());
    };
  }, [dispatch, space_id, passenger_id, cruise_id, reservation_id, booking_id]);

  useEffect(() => {
    if (spacePassenger_id && Object.keys(passengerBySpaceStateCustom.passengerBySpace).length !== 0) {
      setValue('identification', passengerBySpaceStateCustom.passengerBySpace.identification);
      setValue('identification_type_id', passengerBySpaceStateCustom.passengerBySpace.identification_type_id);
      setValue('last_name', passengerBySpaceStateCustom.passengerBySpace.last_name);
      setValue('first_name', passengerBySpaceStateCustom.passengerBySpace.first_name);
      setValue('email', passengerBySpaceStateCustom.passengerBySpace.email);
      setValue('birthdate', passengerBySpaceStateCustom.passengerBySpace.birthdate);
      setValue('country_id', passengerBySpaceStateCustom.passengerBySpace.country_id);
      setValue('gender_id', passengerBySpaceStateCustom.passengerBySpace.gender_id);
      setValue('feed', passengerBySpaceStateCustom.passengerBySpace.feed);
      setValue('medical_information', passengerBySpaceStateCustom.passengerBySpace.medical_information);
      setValue('rent_wetsuits', passengerBySpaceStateCustom.passengerBySpace.rent_wetsuits);
      setValue('special_requirements', passengerBySpaceStateCustom.passengerBySpace.special_requirements);
      setBirthdateInCruise(passengerBySpaceStateCustom.passengerBySpace.birthdateInCruise);
    } else {
      if (passengerBySpaceStateCustom.space && Object.keys(passengerBySpaceStateCustom.space).length !== 0) {
      setValue('gender_id', passengerBySpaceStateCustom.space.gender_id);
      }  
    }
  }, [passengerBySpaceStateCustom.passengerBySpace, passengerBySpaceStateCustom.space, setValue, spacePassenger_id]);

  

  useEffect(() => {
    if (verifyPassengerState.message === "passenger exist") {
      setValue('identification_type_id', verifyPassengerState.passenger.identification_type_id);
      setValue('last_name', verifyPassengerState.passenger.last_name);
      setValue('first_name', verifyPassengerState.passenger.first_name);
      setValue('email', verifyPassengerState.passenger.email);
      setValue('birthdate', verifyPassengerState.passenger.birthdate);
      setValue('country_id', verifyPassengerState.passenger.country_id);
      setValue('gender_id', verifyPassengerState.passenger.gender_id);

      const birthdate = new Date(verifyPassengerState.passenger.birthdate);
      const startDate = new Date(passengerBySpaceStateCustom.cruise.start_date_flight);
      const endDate = new Date(passengerBySpaceStateCustom.cruise.end_date_flight);
      birthdate.setFullYear(startDate.getFullYear());
      const isInCruiseRange = birthdate >= startDate && birthdate <= endDate;
      setBirthdateInCruise(isInCruiseRange);
      setPassengerId(verifyPassengerState.passenger.id)
    }
  }, [verifyPassengerState.message])

  let identificationTypesPassenger = passengerBySpaceStateCustom.identificationTypes?.filter(
    (identificationType) => identificationType?.type === "passenger"
  );

  let notesFood = passengerBySpaceStateCustom.notes?.filter((note) => note?.type === "food");
  let notesMedical = passengerBySpaceStateCustom.notes?.filter((note) => note?.type === "medical");
  let notesWetsuits = passengerBySpaceStateCustom.notes?.filter((note) => note?.type === "wetsuits");
  let notesSpecial = passengerBySpaceStateCustom.notes?.filter((note) => note?.type === "special");
  let notesTransfer = passengerBySpaceStateCustom.notes?.filter((note) => note?.type === "transfer");

  if (passengerBySpaceStateCustom.fetching || passengerBySpaceState.fetching || passengerBySpaceStateCustom.identificationTypes?.length === 0) {
    return <CircularProgress />;
  }

  const handleSearchPassenger = () => {
    const identification = getValues("identification")
    if (identification !== '') {
      dispatch(verifyPassenger(identification));
    }
  };

  const handleShowMessage = (newState) => {
    setState({ open: true, ...newState });

    setTimeout(() => {
      setState({ ...state, open: false });
    }, 6000);
  };

  const onSubmit = (data) => {
    if (spacePassenger_id) {
      data.spacePassenger_id = spacePassenger_id;
      data.passengerIdByBody = passengerId ? passengerId : passengerBySpaceStateCustom.passengerBySpace.passenger_id;
      dispatch(updatePassengerBySpace(booking_id, space_id, passenger_id, data));
    } else {
      dispatch(createPassengerBySpace(booking_id, space_id, data));
    }
  };

  if (passengerBySpaceState.message === "resource created successfully" || passengerBySpaceState.message === "resource updated successfully") {
    history.go(-1);
  }

  const handleBirthdate = (e) => {
    const birthdate = new Date(e);
    const startDate = new Date(passengerBySpaceStateCustom.cruise.start_date_flight);
    const endDate = new Date(passengerBySpaceStateCustom.cruise.end_date_flight);
    birthdate.setFullYear(startDate.getFullYear());
    if (birthdate >= startDate && birthdate <= endDate) {
      setBirthdateInCruise(true);
    }
  };

  const handleInsertNoteTransfer = () => {
    let selectElement = document.getElementById("transferNotes");
    let transferNote = document.getElementById("transfer_notes");
    let day = document.getElementById("day");

    if (transferNote.value === undefined && day === undefined) {
      transferNote.value = "";
      setNoteTransfer((transferNote.value = selectElement.value + transferNote.value));
    } else {
      setNoteTransfer((transferNote.value = transferNote.value + day.value.split("-").reverse().join("-") + " " + selectElement.value));
      setDate("");
    }
    setCleanList((selectElement.value = "notOption"));
  };

  const initialDate = passengerBySpaceStateCustom?.cruise?.start_date_format;
  const handleDateChange = (e, { value }) => {
    setDate(value);
  };

  return (
    <>
      {passengerBySpaceState.error && (
        <Snackbar
          open={open}
          autoHideDuration={6000}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert severity="error" color="error" variant="filled">
            {t(passengerBySpaceState.error)}
          </Alert>
        </Snackbar>
      )}
      <div className="ui breadcrumb">
        <Link to={`/cruises/${cruise_id}/cruise-detail`}>
          <div className="active section">{passengerBySpaceStateCustom.cruise?.code}</div>
        </Link>
        <div className="divider">/</div>
        <div className="active section">
          <Link to={`/cruises/${cruise_id}/reservations`}>
            {t("reservation_title")}
          </Link>
        </div>

        <div className="divider">/</div>
        <div className="active section">
          <Link
            to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings`}
          >
            {t("cabin_title")}
          </Link>
        </div>
        <div className="divider">/</div>
        <div className="active section">
          {t("cabin_cabin")} {passengerBySpaceStateCustom.booking?.cabin_name}
        </div>
        <div className="divider">/</div>
        <div className="active section">
          <Link
            to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking_id}/spaces`}
          >
            {t("space_title")}
          </Link>
        </div>
        <div className="divider">/</div>
        <div className="active section">{t("passenger_path")}</div>
      </div>
      <br />
      <br />
      <HeadDetail
        yacht_name={passengerBySpaceStateCustom.cruise?.yacht_name}
        itinerary_name={passengerBySpaceStateCustom.cruise?.itinerary_name}
        cruise_name={passengerBySpaceStateCustom.cruise.name}
        start_date={passengerBySpaceStateCustom.cruise?.start_date_format}
        end_date={passengerBySpaceStateCustom.cruise?.end_date_format}
      />
      <HeadDetailReservation
        reservation_date={passengerBySpaceStateCustom.reservation?.creation_date}
        reservation_agency={passengerBySpaceStateCustom.reservation?.agency_name}
        reservation_executive={passengerBySpaceStateCustom.reservation?.executive}
        reservation_type={passengerBySpaceStateCustom.reservation?.cruise_type}
      />
      <br />
      <br />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <label className="flex items-center justify-between my-2">{t("passenger_information")} <GenderIcon gender={passengerBySpaceStateCustom.space.gender_name} /></label>
        <Divider variant="fullWidth" />
        <br />

        <Form.Group widths="4">
          <Form.Field required>
            <label>{t("passenger_identification")}</label>
            <input placeholder={t("passenger_identification")} name="identification"
              ref={register({ required: true })}
              style={{ textTransform: "uppercase" }}
            //onChange={(event) => setIdentification(event.target.value)}
            />
            {errors.identification && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field width="4">
            <br></br>
            <Button icon labelPosition='left' color="blue" type="button" onClick={() => handleSearchPassenger()} loading={verifyPassengerState.fetching ? true : false}>
              <Icon name='search plus' />
              Buscar pasajero
            </Button>
          </Form.Field>
          <Form.Field required widths="4">
            <label>{t("passenger_identificationType")}</label>
            <select aria-expanded="true" name="identification_type_id"
              ref={register({ required: true })}
            >
              <option></option>
              {identificationTypesPassenger?.map((identificationType) => (
                <option key={identificationType.id} value={identificationType.id}>{t(identificationType.name)}</option>
              ))}
            </select>
            {errors.identification_type_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
        </Form.Group>
        <br />
        <label>{t("general_information_tag")}</label>
        <Divider variant="fullWidth" />
        <br />

        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("passenger_lastName")}</label>
            <input
              placeholder={t("passenger_lastName")}
              name="last_name"
              style={{ textTransform: "uppercase" }}
              ref={register({ required: true })}
            />
            {errors.last_name && (
              <span className="error_message">
                {t("required_information")}
              </span>
            )}
          </Form.Field>

          <Form.Field required>
            <label>{t("passenger_name")}</label>
            <input
              placeholder={t("passenger_name")}
              name="first_name"
              style={{ textTransform: "uppercase" }}
              ref={register({ required: true })}
            />
            {errors.first_name && (
              <span className="error_message">
                {t("required_information")}
              </span>
            )}
          </Form.Field>

          <Form.Field>
            <label>{t("passenger_email")}</label>
            <input
              placeholder={t("passenger_email")}
              name="email"
              ref={register}
            />
          </Form.Field>
          <Form.Field required>
            <label>
              {t("passenger_birthday")}{" "}
              <span className="text_date_format">(dd-mm-yyyy)</span>
            </label>
            <input
              placeholder={t("passenger_birthday")}
              type="date"
              name="birthdate"
              onChange={(event) => handleBirthdate(event.target.value)}
              ref={register({ required: true })}
            />
            {errors.birthdate && (
              <span className="error_message">
                {t("required_information")}
              </span>
            )}
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("passenger_country")}</label>

            <select
              aria-expanded="true"
              name="country_id"
              ref={register({ required: true })}
            >
              <option></option>
              {passengerBySpaceStateCustom.countries?.map((country) => (
                <option key={country.id} value={country.id}>
                  {t(country.name)}
                </option>
              ))}
            </select>
            {errors.country_id && (
              <span className="error_message">
                {t("required_information")}
              </span>
            )}
          </Form.Field>
          <Form.Field required>
            <label>{t("passenger_gender")}</label>
            <select
              aria-expanded="true"
              name="gender_id"
              ref={register({ required: true })}
            >
              <option></option>
              {passengerBySpaceStateCustom.genders?.map((gender) => (
                <option key={gender.id} value={gender.id}>
                  {t(gender.name)}
                </option>
              ))}
            </select>
            {errors.gender_id && (
              <span className="error_message">
                {t("required_information")}
              </span>
            )}
          </Form.Field>
          {/* Passenger status */}
          <Form.Field >
            <label>{t("passenger_marital_satatus")}</label>
            <select
              aria-expanded="true"
              name="marital_status"
              defaultValue={passengerBySpaceStateCustom.passengerBySpace?.marital_status}
              ref={register()}
            >
              <option></option>
              {status.map((e, index) => (
                <option key={index} value={e.value}>
                  {t(e.name)}
                </option>
              ))}
            </select>
          </Form.Field>

          <Form.Field>
            <Form.Group width="equal">
              <Form.Field >
                <label>{t("passenger_vegetarian")}</label>
                <div className="ui checkbox">
                  <input
                    type="checkbox"
                    name="vegetarian"
                    ref={register}
                    defaultChecked={passengerBySpaceStateCustom.passengerBySpace?.vegetarian}
                  />
                  <label></label>
                </div>
              </Form.Field>
              <Form.Field>
                <label>{t("passenger_glutenFree")}</label>
                <div className="ui checkbox">
                  <input
                    type="checkbox"
                    name="gluten_free"
                    ref={register}
                    defaultChecked={passengerBySpaceStateCustom.passengerBySpace?.gluten_free}
                  />
                  <label></label>
                </div>
              </Form.Field>
              <Form.Field>
                <label>{t("passenger_lactose_intolerant")}</label>
                <div className="ui checkbox">
                  <input
                    type="checkbox"
                    name="lactose_intolerant"
                    ref={register}
                    defaultChecked={passengerBySpaceStateCustom.passengerBySpace?.lactose_intolerant}
                  />
                  <label></label>
                </div>
              </Form.Field>
            </Form.Group>
          </Form.Field>
        </Form.Group>

        <br />
        <label>{t("passenger_payments")}</label>
        <Divider variant="fullWidth" />
        <br />
        <Form.Group width="equal">
          <Form.Field width="8">
            <label>{t("passenger_tct")}</label>
            <div className="ui checkbox">
              <input
                type="checkbox"
                name="tct"
                defaultChecked={passengerBySpaceStateCustom.passengerBySpace?.tct}
                ref={register}
              />
              <label></label>
            </div>
          </Form.Field>

          <Form.Field>
            <label>{t("passenger_gps")}</label>
            <div className="ui checkbox">
              <input
                type="checkbox"
                name="gps"
                defaultChecked={passengerBySpaceStateCustom.passengerBySpace?.gps}
                ref={register}
              />
              <label></label>
            </div>
          </Form.Field>
        </Form.Group>
        {/* --------------------------------------------------NOTAS-------------------------------------------------------------------- */}
        <br />
        <label>{t("passenger_notes")}</label>
        <Divider variant="fullWidth" />
        <br />
        <Form.Group widths="equal">
          <Form.Field>
            <label>{t("passenger_aditional_notes_b2c")}</label>
            <textarea
              rows={5}
              disabled={true}
              placeholder={t("passenger_aditional_notes_b2c")}
              name="aditional_notes"
              defaultValue={passengerBySpaceStateCustom.passengerBySpace?.aditional_notes}
            ></textarea>
          </Form.Field>
        </Form.Group>

        <NoteSelector
          label={t("passenger_foodNotes")}
          name="feed"
          notes={notesFood}
          register={register}
          setValue={setValue}
          watch={watch}
          t={t}
        />

        <NoteSelector
          label={t("passenger_medicalNotes")}
          name="medical_information"
          notes={notesMedical}
          register={register}
          setValue={setValue}
          watch={watch}
          t={t}
        />
        <NoteSelector
          label={t("passenger_wetsuitsNotes")}
          name="rent_wetsuits"
          notes={notesWetsuits}
          register={register}
          setValue={setValue}
          watch={watch}
          t={t}
        />
        <NoteSelector
          label={t("passenger_specialNotes")}
          name="special_requirements"
          notes={notesSpecial}
          register={register}
          setValue={setValue}
          watch={watch}
          t={t}
          birthdateInCruise={birthdateInCruise}
        />
        {/* ------------------------------------------------TRASLADOS------------------------------------------------------------------ */}
        <br />
        <label>{t("passenger_transfers")}</label>
        <Divider variant="fullWidth" />
        <br />
        <Form.Group>
          <Form.Field width="4">
            <label>{t("passenger_day")}</label>
            <DateInput
              name="day"
              id="day"
              placeholder={t("dd/mm/yyyy")}
              value={date}
              onChange={handleDateChange}
              iconPosition="right"
              popupPosition="bottom right"
              closable
              initialDate={initialDate}
              dateFormat="DD/MM/YYYY"
            />
          </Form.Field>

          <Form.Field>
            <label>{t("passenger_message")}</label>

            <select
              aria-expanded="true"
              name="transferNotes"
              id="transferNotes"
              defaultValue={cleanList}
            >
              <option></option>
              {notesTransfer?.map((note) => (
                <option key={note.id} value={note.message}>
                  {note.message}
                </option>
              ))}
            </select>
          </Form.Field>
          <Form.Field>
            <br></br>
            <Button
              icon
              color="blue"
              type="button"
              onClick={() => handleInsertNoteTransfer()}
            >
              <Icon name="plus" />
            </Button>
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field>
            <textarea
              rows={3}
              placeholder={t("passenger_notesTransfer")}
              name="transfer_notes"
              id="transfer_notes"
              defaultValue={passengerBySpaceStateCustom.passengerBySpace?.transfer_notes || noteTransfer}
              ref={register}
              onChange={(event) => setNoteTransfer(event.target.value)}
            ></textarea>
          </Form.Field>
        </Form.Group>

        <Divider variant="middle" />
        <br></br>
        <button type="button" className="ui button" onClick={() => history.go(-1)}>
          {t("canceled_button")}
        </button>
        <button
          type="submit"
          onClick={() => {
            handleShowMessage({
              vertical: "top",
              horizontal: "right",
            });
            scrollToTop();
          }}
          className={passengerBySpaceState.processing ? "ui loading primary button" : "ui primary button"
          }
        >
          {t("save_button")}
        </button>
      </Form>
    </>
  );
}
